module.exports = __webpack_public_path__ + "img/dark-eye.53b3bdd2.svg";